import { render, staticRenderFns } from "./DeactivationReasons.vue?vue&type=template&id=b7fde5da&scoped=true&"
import script from "./DeactivationReasons.vue?vue&type=script&lang=ts&"
export * from "./DeactivationReasons.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivationReasons.vue?vue&type=style&index=0&id=b7fde5da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fde5da",
  null
  
)

export default component.exports